var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.copyMessage.apply(null, arguments)
            }
          }
        },
        [
          _vm.textTruncateLenght
            ? _c("truncate-text-with-hover", {
                attrs: { text: _vm.message, length: _vm.textTruncateLenght }
              })
            : _c("span", [_vm._v(_vm._s(_vm.message))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({}) {
                return [_c("div")]
              }
            }
          ]),
          model: {
            value: _vm.success,
            callback: function($$v) {
              _vm.success = $$v
            },
            expression: "success"
          }
        },
        [_vm._v(" "), _c("span", { staticClass: "caption" }, [_vm._v("Copié")])]
      ),
      _vm._v(" "),
      _c("label", [
        _c("input", {
          ref: "message",
          staticStyle: {
            position: "absolute",
            top: "0",
            opacity: "0",
            "z-index": "-100"
          },
          attrs: { type: "text" },
          domProps: { value: _vm.message }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }